import React, { useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  TextField,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function ViewItemDetails() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [productInput, setproduct] = useState([]);

  const { id } = useParams();
  useEffect(() => {
    const product_id = id;
    axios.get(`/api/view_categorydetails/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        setproduct(res.data.categorydetails);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/categorydetails");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const handleInput = (e) => {
    e.persist();
    setproduct({ ...productInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  return (
    <div>
      <Navbar />

      <form id="CATEGORY_FORM">
        <div className="card px-8 m-5" paddingBottom="10px">
          <div className="card-header" paddingBottom="10px">
            <div class="d-flex justify-content-between">
              <h4>
                Category Details
                {/* <Link to="/product" className='btn btn-primary btn-bg float-end'>Back</Link> */}
              </h4>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/categorydetails"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </div>
          </div>
          <h6 style={{ color: "white" }}>Hello</h6>
          <table class="table table-bordered pb-5">
            <tbody className="pb-5">
              <tr className="pt-5">
                <th>Category Name</th>
                <td onChange={handleInput}>{productInput.categoryname}</td>
                <th>Sub Category Name</th>
                <td onChange={handleInput}>{productInput.subcategoryname}</td>
              </tr>
              <tr className="pt-5">
                <th>Item Name</th>
                <td onChange={handleInput}>{productInput.itemname}</td>
                <th>Item Description</th>
                <td onChange={handleInput}>{productInput.itemdesc}</td>
              </tr>
              <tr className="pt-5">
                <th>Created By</th>
                <td onChange={handleInput}>{productInput.created_by}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
}

export default ViewItemDetails;
